import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Card } from '@mui/material';

import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';

import { CustomerConstants } from '../../Helpers/requests';
import { GetAuth } from '../../Auth/AuthProvider';

import SerialNumberList from './SerialNumberList';
// import SerialActionCard from './SerialActionCard';
// import { useLocalizationContext } from '@mui/x-date-pickers/internals/hooks/useUtils';

function SerialNumber() {
  const [categoriesData, setCategoriesData] = useState([]); //Constant - Categories List
  const [regionsData, setRegionsData] = useState([]); //Constant - Regions List
  const [asset_compData, setAsset_compData] = useState([]); //Constant - Asset Comp List
  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function
  const [useType, setUseType] = useState(localStorage.getItem('type'));

  // const location = useLocation();

  useEffect(() => {
    CustomerConstants({
      resource: `/api/constants/customer`,
      setCategoriesFunc: setCategoriesData,
      setRegionsFunc: setRegionsData,
      setAsset_compFunc: setAsset_compData,
      // setLoadingFunc: setLoading,
      showNotification: enqNotification,
      logout,
    });
  }, [enqNotification, logout]);
  return useType === 'technician' ? <UnauthorisedAccess /> : (
    <Card
      md={{
        background: 'none',
        border: 'none',
        boxShadow: 'none',
        padding: '17px',
      }}
      xs={{ padding: 0 }}
    >
      <SerialNumberList
        categoriesData={categoriesData}
        storeRegion={regionsData}
      />
      {/* <SerialActionCard
        defaultCategory={categoriesData[0]}
        defaultRegion={regionsData[0]}
      /> */}
    </Card>
  );
}

export default SerialNumber;
